import script from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"
export * from "./myMainPageNew.vue?vue&type=script&setup=true&lang=js"

import "./myMainPageNew.vue?vue&type=style&index=0&id=b91225c2&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91225c2"]])

export default __exports__